module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"areYouSure":"Are you sure?"}}')
  delete Component.options._Ctor
}
